// We're using Gutenberg so we need the block styles
import "@wordpress/block-library/build-style/style.css"
import "@wordpress/block-library/build-style/theme.css"
import React, { useEffect } from "react"
import CtaSection from "../components/sections/CtaSection"
import Layout from "../components/global/Layout"
import LearningCenterHeader from "../components/page-specific/Learning Center/LearningCenterHeader/LearningCenterHeader"
import Seo from "gatsby-plugin-wpgraphql-seo"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import { queries } from "../breakpoints"
import styled from 'styled-components';
import { buildTopicHierarchy } from "./resourcesHelperFunctions";
import resources from "./resources";

const defaultBreadcrumbValue = {
  link: "/learning-center/",
  text: "Home",
  active: false
};

const ResourcePostTemplate = ({
  data: { resource, allTopics },
}) => {

  const topicHierarchy = buildTopicHierarchy(allTopics.nodes);
  const [breadcrumbs, setBreadcrumbs] = React.useState([defaultBreadcrumbValue]);
  const [activeAncestor, setActiveAncestor] = React.useState();

  useEffect(() => {
    let seoResourceRawData = resource.seo.schema.raw.replaceAll('item":"', 'item":"https://corporate.grubhub.com');
    resource.seo.schema.raw = seoResourceRawData;
  }, []);

  let breadcrumbsArray = [];
  useEffect( () =>{
    if(resource && resource.topics.nodes.length > 0 && !activeAncestor ){
      resource.topicsNames = [];
      resource.topicsParentId = [];
      resource.topics.nodes.forEach( ( topicInResource ) => {
        resource.topicsNames.push( topicInResource.name );
        resource.topicsParentId.push( topicInResource.parentId );
      } );

      breadcrumbsArray = buildBreadcrumbsFromTopic( topicHierarchy, breadcrumbsArray, 0 );

      breadcrumbsArray.push({
        link: ``,
        text: `${parse( resource.title )}`,
        active: true
      })

      setBreadcrumbs( [ ...breadcrumbs, ...breadcrumbsArray ] );
    }
  }, [])

  const buildBreadcrumbsFromTopic = ( topicsList, breadcrumbsArray, level, linkLevels ) => {
    topicsList.forEach( ( topic ) => {

      if( linkLevels === undefined ){
        linkLevels = getLinkURL( topic, level, [] );
      }

      if( resource.topicsNames.includes( topic.name ) && resource.topicsParentId.includes( topic.parentId ) ) {
        linkLevels = getLinkURL( topic, level, linkLevels );
        breadcrumbsArray.push( {
          link: (level === 0 ? linkLevels[level] : linkLevels[level+1]),
          text: `${topic.name}`,
          active: false
        } );
      }
      if( topic.subTopics.length > 0 ) {
        linkLevels = ( level === 0 ) ? getLinkURL(topic, level + 1, linkLevels ) : linkLevels;
        breadcrumbsArray = buildBreadcrumbsFromTopic( topic.subTopics, breadcrumbsArray, level + 1, linkLevels );
      }
      if( level === 0 && breadcrumbsArray.length > 0 && !resource.topicsNames.includes( topic.name ) ) {
        level++;
        breadcrumbsArray = [
          {
            link: "/learning-center#-" + topic.name,
            text: `${topic.name}`,
            active: false
          },
          ...breadcrumbsArray
        ]
      }

    } );

    return breadcrumbsArray;
  }

  const getLinkURL = ( topic, level, linkLevels ) => {
    if( level === 0 ) {
      linkLevels[0] = "/learning-center#-" + topic.name.replace(' ', '-').toLowerCase();
      linkLevels[1] = "/resources?resource_parent=" + topic.name;
    }
    if( level === 1 ) {
      linkLevels[2] = linkLevels[1] + '&resource_type=' + topic.name;
    }
    if( level === 2 ) {
      linkLevels[3] = linkLevels[1] + '&resource_type=' + topic.name
    }

    return linkLevels;
  }


  const switchMasterTopics = (masterTopic) => {
    window.location.href = `/resources?resource_type=${masterTopic}`
  }

  return (
    <Layout
      title={parse(resource.title)}
      description={resource.seo.metaDesc}
      noindex={resource.seo.metaRobotsNoindex === "noindex"}
      nofollow={resource.seo.metaRobotsNofollow === "nofollow"}
      utag_data={{
        pageGroup: "grubhub - lead generation",
        subGroup: "learn more",
        pageName: `resource - ${resource.title}`,
        brand: "grubhub"
      }}
    >
      {/* Seo component provided by gatsby-plugin-wpgraphql-seo */}
      <Seo post={resource} />
      <LearningCenterHeader
        breadcrumbs={breadcrumbs || [defaultBreadcrumbValue]}
        allTopics={allTopics}
        activeAncestor={activeAncestor}
        switchMasterTopics={(masterTopic) => switchMasterTopics(masterTopic)}
      />
      <ArticleResourceSingle>
        <article
          itemScope
          itemType="http://schema.org/Article"
          className="corporate-learning-center-post container"
        >
          <Headline itemProp="headline">{parse(resource.title)}</Headline>
          {!!resource.content && (
            <section itemProp="articleBody" className=" article-body">
              {parse(resource.content)}
            </section>
          )}
          {resource.modified && <LastUpdated>Last updated on {resource.modified}</LastUpdated>}
        </article>
      </ArticleResourceSingle>
      <CtaSection
        headline="Still have questions?"
        to="/get-started/"
        backgroundColor="#F9F9F9"
      />
    </Layout>
  )
}

export default ResourcePostTemplate

export const pageQuery = graphql`
  query ResourcePostById(
    # these variables are passed in via createPage.pageContext in gatsby-node.js
    $id: String!
  ) {
    # selecting the current resource by id
    allTopics: allWpTopic {
      nodes {
        id
        name
        description
        parentId

      }
    }
    resource: wpResource(id: { eq: $id }) {
      id
      content
      title
      date(formatString: "MMMM DD, YYYY")
      modified(formatString: "MMMM DD, YYYY")
      uri
      categories {
        nodes {
          slug
        }
      }
      topics {
        nodes {
          name
          termTaxonomyId
          parentId
        }
      }
      seo {
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        canonical
        cornerstone
        schema {
          articleType
          pageType
          raw
        }
      }
    }
  }
`

const Headline = styled.h1`
  color: var(--color-text);
  font-size: var(--fontSize-8);
  font-weight: bold;
  margin-bottom: 2rem;
  @media(${queries.max_break_sm}){
    font-size: var(--fontSize-4);
  }
`

const LastUpdated = styled.p`
  color: #AEAEAE;
  font-size: var(--fontSize-0);
  margin: 2rem 0;
`

const ArticleResourceSingle = styled.div`
  .resource__single_cta {
    display: inline;
    padding: 12px 30px;
    border-radius: 100px;
    font-weight: bold;
    font-size: var(--fontSize-1);
    min-width: 175px;
    display: inline-block;
    text-align: center;
    background-color: var(--color-primary);
    color: white;
    font-family: var(--font-body);
    border: none;
    transition: all .1s;
    &:hover {
        color: white;
        text-decoration: none;
        background-color: var(--color-primary-dark);
    }
    &:active{
        background-color: var(--color-primary-darker);
    }
  }
`
